<template>
  <AdminLayout>
    <Head title="Company Settings" />

    <template #pageTitle> Company </template>

    <div class="item form bg-gray-100 rounded-lg shadow p-10">
      <div class="sm:border-b sm:border-gray-400 sm:pb-5 sm:mb-5">
        <h3 class="text-lg leading-6 font-semibold text-blue-600">Company Detail</h3>
        <p class="mt-1 max-w-2xl text-sm text-gray-600">General company information used to define the instance.</p>
      </div>

      <form
        method="POST"
        @submit.prevent=""
      >
        <div class="grid grid-cols-12 gap-6">
          <div class="input-group col-span-12 sm:col-span-12">
            <label for="name"> Company Name </label>
            <input
              type="text"
              disabled
              class="input-text"
              v-model="form.name"
              name="name"
              id="name"
              autocomplete="given-name"
            />
          </div>

          <div class="input-group col-span-6 sm:col-span-6 lg:col-span-4">
            <label for="phone"> Phone </label>
            <input
              type="text"
              disabled
              class="input-text"
              v-model="form.phone"
              name="phone"
              id="phone"
            />
          </div>

          <div class="input-group col-span-6 sm:col-span-3 lg:col-span-4">
            <label for="email"> Email </label>
            <input
              type="text"
              disabled
              class="input-text"
              v-model="form.email"
              name="email"
              id="email"
            />
          </div>

          <div class="input-group col-span-6 sm:col-span-3 lg:col-span-4">
            <label for="website_url"> Website </label>
            <input
              type="text"
              disabled
              class="input-text"
              v-model="form.website_url"
              name="website_url"
              id="website_url"
            />
          </div>

          <div class="input-group col-span-12 sm:col-span-6">
            <label for="icon"> Icon </label>
            <div class="mt-1 relative rounded-md shadow-sm">
              <input
                type="text"
                disabled
                class="input-text"
                name="icon"
                id="icon"
                :value="company.icon_name"
              />
              <div
                v-if="company.icon_url"
                @click="openImage(company.icon_url)"
                class="absolute inset-y-0 left-0 right-0 cursor-pointer"
              ></div>
            </div>
          </div>

          <div class="input-group col-span-12 sm:col-span-6">
            <label for="icon"> Logo </label>
            <div class="mt-1 relative rounded-md shadow-sm">
              <input
                type="text"
                disabled
                class="input-text"
                name="logo"
                id="logo"
                :value="company.logo_name"
                @click="openImage(company.logo_url)"
              />
              <div
                v-if="company.logo_url"
                @click="openImage(company.logo_url)"
                class="absolute inset-y-0 left-0 right-0 cursor-pointer"
              ></div>
            </div>
          </div>

          <div class="input-group col-span-12 sm:col-span-12">
            <label for="address_1"> HQ Address 1 </label>
            <input
              type="text"
              disabled
              class="input-text"
              v-model="form.address.street_1"
              name="address[address_1]"
              id="address_1"
              autocomplete="address_1"
            />
          </div>

          <div class="input-group col-span-12 sm:col-span-12">
            <label for="address_2"> HQ Address 2 </label>
            <input
              type="text"
              disabled
              class="input-text"
              v-model="form.address.street_2"
              name="address[address_2]"
              id="address_2"
              autocomplete="address_2"
            />
          </div>

          <div class="input-group col-span-6 sm:col-span-6 lg:col-span-4">
            <label for="city"> HQ City </label>
            <input
              type="text"
              disabled
              class="input-text"
              v-model="form.address.city"
              name="address[city]"
              id="city"
            />
          </div>

          <div class="input-group col-span-6 sm:col-span-3 lg:col-span-4">
            <label for="state"> HQ State </label>
            <input
              type="text"
              disabled
              class="input-text"
              v-model="form.address.state"
              name="address[state]"
              id="state"
            />
          </div>

          <div class="input-group col-span-6 sm:col-span-3 lg:col-span-4">
            <label for="zip"> HQ Zip </label>
            <input
              type="text"
              disabled
              class="input-text"
              v-model="form.address.zip"
              name="address[zip]"
              id="zip"
            />
          </div>
        </div>
      </form>
    </div>
  </AdminLayout>
</template>

<script>
import AdminLayout from '@/Layouts/AdminLayout.vue'
import { Head, Link } from '@inertiajs/vue3'

export default {
  components: {
    AdminLayout,
    Head,
    Link
  },

  props: {
    company: Object
  },

  data() {
    return {
      form: {
        name: null,
        phone: null,
        email: null,
        website_url: null,
        address: {
          address_1: null,
          address_2: null,
          city: null,
          state: null,
          zip: null
        }
      }
    }
  },

  created() {
    this.form = {
      ...this.form,
      ...(this.company || {})
    }
  },

  methods: {
    openImage(url) {
      if (!url) {
        return
      }

      window.open(url, '_blank')
    }
  }
}
</script>
